<template>
  <div class="pagination-container">
    <div class="d-flex align-items-center gap-5" v-if="showLimitInput">
      <span class="fsc-12">Выводить по</span>
      <div>
        <BaseSelect
          v-model="limitValue"
          style="width: 50px"
          placeholder=""
          selectLabel=""
          deselectLabel=""
          @input="setSelect"
          id="city"
          label="label"
          :options="[
            { label: 10, value: 10 },
            { label: 50, value: 50 },
            { label: 100, value: 100 }
          ]"
        >
          <!-- <template slot="noOptions">{{ dataLang['select_empty'] }}</template>
          <template slot="noResult">{{
            dataLang['select_search_empty']
          }}</template
          ><template slot="selectedLabel">{{
            dataLang['select_selected']
          }}</template>
          <template slot="deselectLabel">{{
            dataLang['select_unselect']
          }}</template> -->
        </BaseSelect>
      </div>
      <span class="fsc-12">записей</span>
    </div>
    <div class="pagination-info">
      Показано {{ paginationParams.count }} из {{ paginationParams.total }}
    </div>
    <ul :class="containerClass" v-if="!noLiSurround">
      <li
        v-if="firstLastButton"
        :class="[pageClass, firstPageSelected() ? disabledClass : '']"
      >
        <a
          @click="selectFirstPage()"
          @keyup.enter="selectFirstPage()"
          :class="pageLinkClass"
          :tabindex="firstPageSelected() ? -1 : 0"
        >
        </a>
      </li>

      <li
        v-if="!(firstPageSelected() && hidePrevNext)"
        :class="[
          prevClass,
          firstPageSelected() ? disabledClass : '',
          pageClass
        ]"
        class="page-item"
      >
        <a
          @click="prevPage()"
          @keyup.enter="prevPage()"
          :class="[prevLinkClass, pageLinkClass]"
          :tabindex="firstPageSelected() ? -1 : 0"
          ><svg
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.78065 0.28186L9.7908 1.29897L6.01016 5.10566L9.7908 8.91235L8.78065 9.92946L3.98986 5.10566L8.78065 0.28186ZM5.20922 0.28186L6.21937 1.29897L2.43874 5.10566L6.21937 8.91235L5.20922 9.92946L0.41843 5.10566L5.20922 0.28186Z"
              fill="#1D1E2C"
            /></svg
        ></a>
      </li>

      <li
        v-for="page in pages"
        :class="[
          pageClass,
          page.selected ? activeClass : '',
          page.disabled ? disabledClass : '',
          page.breakView ? breakViewClass : ''
        ]"
      >
        <a
          v-if="page.breakView"
          :class="[pageLinkClass, breakViewLinkClass]"
          tabindex="0"
          ><slot name="breakViewContent">{{ breakViewText }}</slot></a
        >
        <a v-else-if="page.disabled" :class="pageLinkClass" tabindex="0">{{
          page.content
        }}</a>
        <a
          v-else
          @click="handlePageSelected(page.index + 1)"
          @keyup.enter="handlePageSelected(page.index + 1)"
          :class="pageLinkClass"
          tabindex="0"
          >{{ page.content }}</a
        >
      </li>

      <li
        v-if="!(lastPageSelected() && hidePrevNext)"
        :class="[nextClass, lastPageSelected() ? disabledClass : '', pageClass]"
        class="page-item"
      >
        <a
          @click="nextPage()"
          @keyup.enter="nextPage()"
          :class="[prevLinkClass, pageLinkClass]"
          :tabindex="lastPageSelected() ? -1 : 0"
          ><svg
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M1.21938 0.28186L0.209229 1.29897L3.98987 5.10566L0.209229 8.91235L1.21938 9.92946L6.01017 5.10566L1.21938 0.28186ZM4.79081 0.28186L3.78066 1.29897L7.5613 5.10566L3.78066 8.91235L4.79081 9.92946L9.5816 5.10566L4.79081 0.28186Z"
              fill="#1D1E2C"
            /></svg
        ></a>
      </li>
    </ul>

    <!-- <div :class="containerClass" v-else>
    <a v-if="firstLastButton" @click="selectFirstPage()" @keyup.enter="selectFirstPage()" :class="[pageLinkClass, firstPageSelected() ? disabledClass : '']" tabindex="0" v-html="firstButtonText"></a>
    <a v-if="!(firstPageSelected() && hidePrevNext)" @click="prevPage()" @keyup.enter="prevPage()" :class="[prevLinkClass, firstPageSelected() ? disabledClass : '']" tabindex="0" v-html="prevText"></a>
    <template v-for="page in pages">
      <a v-if="page.breakView" :class="[pageLinkClass, breakViewLinkClass, page.disabled ? disabledClass : '']" tabindex="0"><slot name="breakViewContent">{{ breakViewText }}</slot></a>
      <a v-else-if="page.disabled" :class="[pageLinkClass, page.selected ? activeClass : '', disabledClass]" tabindex="0">{{ page.content }}</a>
      <a v-else @click="handlePageSelected(page.index + 1)" @keyup.enter="handlePageSelected(page.index + 1)" :class="[pageLinkClass, page.selected ? activeClass : '']" tabindex="0">{{ page.content }}</a>
    </template>
    <a v-if="!(lastPageSelected() && hidePrevNext)" @click="nextPage()" @keyup.enter="nextPage()" :class="[nextLinkClass, lastPageSelected() ? disabledClass : '']" tabindex="0" v-html="nextText"></a>
    <a v-if="firstLastButton" @click="selectLastPage()" @keyup.enter="selectLastPage()" :class="[pageLinkClass, lastPageSelected() ? disabledClass : '']" tabindex="0" v-html="lastButtonText"></a>
  </div> -->
  </div>
</template>

<script>
export default {
  props: {
    defaultValueLimit: {
      type: Number,
      default: 100
    },
    paginationParams: {
      type: Object
    },
    value: {
      type: Number
    },
    pageCount: {
      type: Number,
      required: true
    },
    forcePage: {
      type: Number
    },
    clickHandler: {
      type: Function,
      default: () => {}
    },
    pageRange: {
      type: Number,
      default: 3
    },
    marginPages: {
      type: Number,
      default: 1
    },
    prevText: {
      type: String,
      default: 'Prev'
    },
    nextText: {
      type: String,
      default: 'Next'
    },
    breakViewText: {
      type: String,
      default: '…'
    },
    containerClass: {
      type: String
    },
    pageClass: {
      type: String
    },
    pageLinkClass: {
      type: String
    },
    prevClass: {
      type: String
    },
    prevLinkClass: {
      type: String
    },
    nextClass: {
      type: String
    },
    nextLinkClass: {
      type: String
    },
    breakViewClass: {
      type: String
    },
    breakViewLinkClass: {
      type: String
    },
    activeClass: {
      type: String,
      default: 'active'
    },
    disabledClass: {
      type: String,
      default: 'disabled'
    },
    noLiSurround: {
      type: Boolean,
      default: false
    },
    firstLastButton: {
      type: Boolean,
      default: false
    },
    firstButtonText: {
      type: String,
      default: 'First'
    },
    lastButtonText: {
      type: String,
      default: 'Last'
    },
    hidePrevNext: {
      type: Boolean,
      default: false
    },
    showLimitInput: {
      type: Boolean,
      default: true
    }
  },
  beforeUpdate() {
    if (this.forcePage === undefined) return
    if (this.forcePage !== this.selected) {
      this.selected = this.forcePage
    }
  },
  computed: {
    selected: {
      get: function () {
        return this.value || this.innerValue
      },
      set: function (newValue) {
        this.innerValue = newValue
      }
    },
    pages: function () {
      let items = {}
      if (this.pageCount <= this.pageRange) {
        for (let index = 0; index < this.pageCount; index++) {
          let page = {
            index: index,
            content: index + 1,
            selected: index === this.selected - 1
          }
          items[index] = page
        }
      } else {
        const halfPageRange = Math.floor(this.pageRange / 2)
        console.log(
          halfPageRange,
          this.pageRange,
          '-------------const halfPageRange'
        )
        let setPageItem = (index) => {
          let page = {
            index: index,
            content: index + 1,
            selected: index === this.selected - 1
          }

          items[index] = page
        }

        let setBreakView = (index) => {
          let breakView = {
            disabled: true,
            breakView: true
          }

          items[index] = breakView
        }

        // 1st - loop thru low end of margin pages
        for (let i = 0; i < this.marginPages; i++) {
          setPageItem(i)
        }

        // 2nd - loop thru selected range
        let selectedRangeLow = 0
        if (this.selected - halfPageRange > 0) {
          selectedRangeLow = this.selected - 1 - halfPageRange
        }

        let selectedRangeHigh = selectedRangeLow + this.pageRange - 1
        if (selectedRangeHigh >= this.pageCount) {
          selectedRangeHigh = this.pageCount - 1
          selectedRangeLow = selectedRangeHigh - this.pageRange + 1
        }

        for (
          let i = selectedRangeLow;
          i <= selectedRangeHigh && i <= this.pageCount - 1;
          i++
        ) {
          setPageItem(i)
        }

        // Check if there is breakView in the left of selected range
        if (selectedRangeLow > this.marginPages) {
          setBreakView(selectedRangeLow - 1)
        }

        // Check if there is breakView in the right of selected range
        if (selectedRangeHigh + 1 < this.pageCount - this.marginPages) {
          setBreakView(selectedRangeHigh + 1)
        }

        // 3rd - loop thru high end of margin pages
        for (
          let i = this.pageCount - 1;
          i >= this.pageCount - this.marginPages;
          i--
        ) {
          setPageItem(i)
        }
      }
      return items
    }
  },
  data() {
    return {
      innerValue: 1,
      limitValue: 10
    }
  },
  mounted() {
    if (this.paginationParams.limit) {
      this.limitValue = {label: this.paginationParams.limit, value: this.paginationParams.limit}
    }
  },
  methods: {
    setSelect(data) {
      this.$emit('updateLimitValue', data.value)
    },
    handlePageSelected(selected) {
      if (this.selected === selected) return

      this.innerValue = selected
      this.$emit('input', selected)
      this.clickHandler(selected)
    },
    prevPage() {
      if (this.selected <= 1) return

      this.handlePageSelected(this.selected - 1)
    },
    nextPage() {
      if (this.selected >= this.pageCount) return

      this.handlePageSelected(this.selected + 1)
    },
    firstPageSelected() {
      return this.selected === 1
    },
    lastPageSelected() {
      return this.selected === this.pageCount || this.pageCount === 0
    },
    selectFirstPage() {
      if (this.selected <= 1) return

      this.handlePageSelected(1)
    },
    selectLastPage() {
      if (this.selected >= this.pageCount) return

      this.handlePageSelected(this.pageCount)
    }
  }
}
</script>

<style lang="css" scoped>
a {
  cursor: pointer;
}
</style>
